module.exports = __webpack_public_path__ + "41b939b281b1252cd02b5fc955aa060a.pdf";